import { Component, OnInit } from '@angular/core';
import { ImportantAlert } from '../../../models/important-alert.interface';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';

export interface ImportantAlertPopupInput {
  alert: ImportantAlert;
}

export interface ImportantAlertPopupResult {
  confirmed: boolean;
}

@Component({
  selector: 'app-important-alert-popup',
  templateUrl: './important-alert-popup.component.html',
  styleUrls: ['./important-alert-popup.component.scss']
})
export class ImportantAlertPopupComponent implements OnInit, IDialogContentComponent<ImportantAlertPopupResult, ImportantAlertPopupInput> {
  input?: ImportantAlertPopupInput;
  alert!: ImportantAlert;

  ngOnInit(): void {
    if (this.input?.alert) {
      this.alert = this.input.alert;
    }
  }

  getResult(): ImportantAlertPopupResult {
    return { confirmed: true };
  }

  isDisabled(): boolean {
    return false;
  }
}
